/**
 * Sort dimensions for display or further evaluation according to pirateship's
 * convention: i.e. from largest to smallest
 */
export default function sortDims(dimArray: number[]): number[] {
  return dimArray.sort((a, b) => b - a);
}
